import type { MembersChangeChart } from '@fourthwall/module-analytics'

import type { Chart } from '../AnalyticsOverview.types'

export const prepareSingleValueChart = (chart: MembersChangeChart | undefined): Chart => {
  if (!chart) {
    return { timestamps: [], values: [] }
  }

  return {
    timestamps: chart.timestamps,
    values: chart.values.map(({ value }) => value),
  }
}
